import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import sectionStyles from './index.module.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const darkBtnTheme = createMuiTheme({ palette: { primary: { main: '#000000' } } });

class MainSection extends React.Component {
  render() {
    return (
      <section className={`${sectionStyles.pageSection} section`}>
        <div className={sectionStyles.heroOverlay} aria-hidden="true" />
        <Grid container spacing={0} alignItems="center" className={`${sectionStyles.contentContainer} contentContainer`}>
          <Grid item xs={12}>
            <div className={`${sectionStyles.inner} m-auto`}>
              <p className={sectionStyles.eyebrow}>M3</p>
              <h1 className={sectionStyles.title}>Pricing</h1>
              <p className={sectionStyles.lead}>
                Straightforward monthly plans by member count. Need collections or M3 Plus? We&apos;ll scope it with you.
              </p>
              <MuiThemeProvider theme={darkBtnTheme}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={sectionStyles.cta}
                  component={GatsbyLink}
                  to="/contact/"
                >
                  Ask about M3 Plus
                </Button>
              </MuiThemeProvider>
            </div>
          </Grid>
        </Grid>
      </section>
    );
  }
}

export default MainSection;
